<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <ul
      id="example-1"
      v-else-if="!this.loading && !this.errormessage && this.faqs.length > 0"
    >
      <div
        v-for="item in faqs"
        :key="item.Id"
      >
        <i class="h5 bi bi-chat-quote mr-2 text-danger" /><span class="h6"><b>{{ item.Question }}</b></span>
        <p
          class="p-2 text-muted"
          v-html="item.Answer"
        />
      </div>
    </ul>
    <div v-else>
      There are currently no FAQs to show you.
    </div>
  </div>
</template>

<script>
import faqsApi from '@/services/api/faqs'
import oops from '@/components/_main/oops.vue'

export default {
  name: 'Faqs',
  components: {
    oops
  },
  data: function () {
    return {
      faqs: null,
      loading: true,
      errormessage: null
    }
  },
  mounted () {
    faqsApi.get(this.$root.courseKey)
      .then(x => {
        this.faqs = x
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
